<div class="flex justify-center p-5 items-center">
  <div class="mr-5">
    <select [(ngModel)]="urlBackend" class="text-xl p-4">
      <option value="https://backend-uniges.pmc.tn/api/" selected>
        UNIGES
      </option>
      <option value="http://backend-batouta.pmc.tn/api/">BATOUTA</option>
      <option value="http://srv-msgi.pmc.tn/api/">MSGI</option>
    </select>
  </div>
  <div
    class="flex flex-row border h-40 w-80 rounded-lg border-gray-400 relative"
  >
    <button
      (click)="updateSize(-1)"
      class="font-semibold border-r bg-red-700 hover:bg-red-600 text-white border-gray-400 h-full w-80 flex rounded-l focus:outline-none cursor-pointer"
    >
      <span class="m-auto text-2xl px-10">-</span>
    </button>

    <div
      class="bg-white w-50 text-2xl md:text-base flex items-center justify-center cursor-default px-8"
    >
      <span>{{ editorOptions.fontSize }}</span>
    </div>

    <button
      (click)="updateSize(1)"
      class="font-semibold border-l bg-blue-700 hover:bg-blue-600 text-white border-gray-400 h-full w-80 flex rounded-r focus:outline-none cursor-pointer"
    >
      <span class="m-auto text-2xl px-8">+</span>
    </button>
  </div>
  <button
    class="px-5 py-3 ml-20 rounded-md bg-blue-500 text-white"
    (mousedown)="shearchBoth()"
  >
    Rechercher
  </button>
</div>
<div class="flex p-16 gap-4 w-full h-full justify-around">
  <div class="flex flex-col w-full h-full">
    <div class="flex w-full my-4 shadow-md">
      <input
        type="text"
        name=""
        placeholder="tbre key"
        id=""
        class="px-5 py-3 rounded-l-md w-9/12 border"
        [(ngModel)]="tbreKEY"
        (keyup.enter)="searchTable()"
      />
      <input
        type="text"
        name=""
        placeholder="params"
        id=""
        class="px-5 py-3 rounded-r-md w-9/12 border"
        [(ngModel)]="tbreKEYParam"
        (keyup.enter)="searchTable()"
      />
    </div>
    <ngx-monaco-editor
      *ngIf="!blink"
      style="width: 100%; height: 100%"
      [options]="editorOptions"
      [(ngModel)]="codeTbre"
    ></ngx-monaco-editor>
  </div>
  <div class="flex flex-col w-full h-full">
    <div class="flex w-full my-4 shadow-md">
      <input
        type="text"
        name=""
        placeholder="ds key"
        id=""
        class="px-5 py-3 rounded-l-md w-9/12 border"
        [(ngModel)]="dsKEY"
        (keyup.enter)="ds()"
      />
      <input
        type="text"
        name=""
        placeholder="tbre key"
        id=""
        class="px-5 py-3 rounded-r-md w-3/12 border"
        [(ngModel)]="dsKEYParam"
        (keyup.enter)="searchTable()"
      />
    </div>
    <ngx-monaco-editor
      *ngIf="!blink"
      class="text-2xl"
      style="width: 100%; height: 100%"
      [options]="editorOptions"
      [(ngModel)]="codeDs"
    ></ngx-monaco-editor>
  </div>
</div>
